interface GoalsStatsProps {
  completed: number
  inProgress: number
  total: number
}

export default function GoalsStats({ completed, inProgress, total }: GoalsStatsProps) {
  return (
    <div className="flex-1 w-full">
      <h2 className="mb-4 text-xl font-bold text-slate-900">Your Progress Summary</h2>
      <p className="mb-6 text-slate-500">Great job staying on track! Here's a look at how your goals are shaping up.</p>
      <div className="space-y-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3">
            <span className="h-3 w-3 rounded-full bg-emerald-500" />
            <span className="font-medium text-slate-600">Completed</span>
          </div>
          <span className="font-bold text-slate-800">{completed} Goals</span>
        </div>
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3">
            <span className="h-3 w-3 rounded-full bg-amber-500" />
            <span className="font-medium text-slate-600">In Progress</span>
          </div>
          <span className="font-bold text-slate-800">{inProgress} Goals</span>
        </div>
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3">
            <span className="h-3 w-3 rounded-full bg-slate-300" />
            <span className="font-medium text-slate-600">Total Goals</span>
          </div>
          <span className="font-bold text-slate-800">{total} Goals</span>
        </div>
      </div>
    </div>
  )
}
